import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-back",
  "use": "icon-back-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-back\">\r\n<path d=\"M11.1324 6.46873V3.31404C10.8488 1.99451 9.76837 2.79842 9.76837 2.79842L2.26368 9.27889C0.613681 10.425 2.15118 11.2875 2.15118 11.2875L9.54337 17.7117C11.0223 18.8015 11.1348 17.1375 11.1348 17.1375V14.2125C18.6395 11.8594 21.7098 21.2695 21.7098 21.2695C21.9934 21.7851 22.1645 21.2695 22.1645 21.2695C25.0637 7.15779 11.1324 6.46873 11.1324 6.46873Z\" fill=\"white\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol